module.exports = __webpack_public_path__ + "img/ChartStart.7e818d81.png";